<ng-template #shapeTemplate>
    <svg:image attr.id="{{shape.shapeProperties.name}}" class="draggable" attr.x="{{ shape.originX }}" attr.y="{{ shape.originY }}"
        attr.height="{{ shape.height }}" attr.width="{{ shape.width }}" attr.xlink:href="{{ shape.url }}">
        <title>{{ shape.shapeProperties.name }}</title>
    </svg:image>
</ng-template>
